import { type ResultOf } from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

import { useBrandAccountId } from './useBrandAccountId'

const document = graphql(`
  mutation TimeSeriesSettingsPage_CreateSurveyGroup(
    $brandAccountId: String!
    $title: String!
  ) {
    createSurveyGroup(brandAccountId: $brandAccountId, title: $title) {
      id
    }
  }
`)

export const useCreateSurveyGroupMutation = (
  options: Omit<
    UseMutationOptions<ResultOf<typeof document>, unknown, string, unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const brandAccountId = useBrandAccountId()

  return useMutation({
    mutationFn: (title) =>
      graphQLRequest({
        document,
        variables: { brandAccountId, title },
      }),
    ...options,
  })
}
